module.exports = __webpack_public_path__ + "static/media/trees.4d6d9cd5.svg";